import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Mendoza',
    product: 'MEGAPACK + Potenciadores',
    text: 'Antes llegaba agotada al lunes. Ahora abro el tomo y en 5 minutos tengo todo.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata',
    product: 'Booty Builder',
    text: 'Mis alumnas me piden que no cambie esas clases nunca. Y les cobro diferenciado.',
    bg: 'bg-brandBlue-electric'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Santa Fe',
    product: 'Metabolic Overload',
    text: 'En 4 semanas, 3 alumnos bajaron de la meseta. Los números no mienten.',
    bg: 'bg-brandOrange'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén',
    product: 'Box Games',
    text: 'Convirtió mi grupo en familia. Me avisan si no pueden venir.',
    bg: 'bg-brandBlue-electric'
  }];
  return <Section className="bg-bg-alt" data-id="element-179">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-180">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary mb-3 md:mb-4" data-id="element-181">
          Lo que dicen <span className="text-brandOrange" data-id="element-182">los profes</span>
        </h2>
        <div className="inline-flex items-center gap-2 bg-bg-card border border-line rounded-full px-4 py-2" data-id="element-183">
          <div className="flex text-gold" data-id="element-184">
            {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-current" data-id="element-185" />)}
          </div>
          <span className="font-sans font-bold text-txt-primary text-sm" data-id="element-186">
            4.9/5
          </span>
          <span className="font-sans text-txt-muted text-xs md:text-sm" data-id="element-187">
            · +150 entrenadores del país
          </span>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4" data-id="element-188">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-189">
            <div className="bg-bg-card p-4 md:p-5 rounded-[16px] border border-line h-full flex flex-col" data-id="element-190">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-191">
                <div className={`w-9 h-9 ${t.bg} text-white rounded-full flex items-center justify-center font-sans font-bold text-xs shrink-0`} data-id="element-192">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-193">
                  <div className="flex text-gold mb-0.5" data-id="element-194">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-195" />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[13px] leading-tight" data-id="element-196">
                    {t.name}
                  </p>
                  <p className="text-[11px] font-sans text-txt-muted" data-id="element-197">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[13px] md:text-[14px] leading-[1.5] italic mb-2.5" data-id="element-198">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandOrange mt-auto" data-id="element-199">
                {t.product}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-bg-base" data-id="element-200">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-201">
        <div className="bg-bg-card border border-[rgba(34,197,94,0.2)] rounded-[20px] p-8 md:p-10 relative overflow-hidden" data-id="element-202">
          <div className="absolute inset-0 bg-gradient-to-b from-[rgba(212,164,28,0.05)] to-transparent pointer-events-none" data-id="element-203"></div>
          <ShieldCheck size={70} className="mx-auto text-gold mb-5 md:mb-6 relative z-10" data-id="element-204" />
          <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-txt-primary mb-6 md:mb-8 relative z-10" data-id="element-205">
            🛡️ GARANTÍA 15 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body space-y-3 md:space-y-4 mb-6 md:mb-8 relative z-10" data-id="element-206">
            <p data-id="element-207">Abrís los tomos. Los usás en tus clases.</p>
            <p className="font-sans font-bold text-lg md:text-xl text-txt-primary leading-snug py-2" data-id="element-208">
              Si en 15 días no es lo que esperabas:
              <br data-id="element-209" />
              devolución del 100%.
            </p>
            <p data-id="element-210">Sin formularios. Sin drama. Sin vueltas.</p>
          </div>
          <p className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-txt-muted relative z-10" data-id="element-211">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para cualquier nivel de grupo?',
    a: 'Sí. Cada sesión incluye Versión A para principiantes, Versión B para intermedios y Versión C para avanzados. Podés dictar la misma clase a un grupo mixto sin problema.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un correo con el link de descarga. En menos de 5 minutos tenés todo en tu celular, tablet o computadora.'
  }, {
    q: '¿Necesito equipamiento especial para usarlo?',
    a: 'No. La mayoría de las sesiones se pueden dictar con equipamiento básico de cualquier gym: mancuernas, kettlebells y bandas. Cada sesión indica los materiales necesarios con íconos.'
  }, {
    q: '¿Funciona si no soy profe de escuela sino instructor de gym?',
    a: 'Este producto fue creado específicamente para instructores y coaches de funcional en gimnasios, boxes y grupos. Es exactamente para vos.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 15 días sin preguntas. Si no es lo que esperabas, mandás un mail y devolvemos el 100% del pago. Sin formularios. Sin drama.'
  }, {
    q: '¿Los Potenciadores se pueden usar junto al MEGAPACK?',
    a: 'Sí. Los Potenciadores están diseñados para complementar el MEGAPACK. Podés usarlos como sesiones adicionales, como reemplazo de días específicos, o como programas independientes de 8 semanas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-bg-alt" data-id="element-212">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-213">
        <h2 className="font-display font-extrabold uppercase text-[28px] md:text-[44px] leading-[1.1] text-txt-primary text-center mb-8 md:mb-10" data-id="element-214">
          ❓ LO QUE MÁS NOS <span className="text-brandOrange" data-id="element-215">PREGUNTAN</span>
        </h2>
        <div className="space-y-3 md:space-y-4" data-id="element-216">
          {faqs.map((faq, i) => <div key={i} className={`bg-bg-card border border-line rounded-[16px] overflow-hidden transition-colors ${openIndex === i ? 'bg-bg-highlight' : ''}`} data-id="element-217">
              <button className="w-full px-5 py-4 md:px-6 md:py-5 text-left flex justify-between items-center gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-218">
                <span className="font-sans font-bold text-[14px] md:text-[16px] text-txt-primary" data-id="element-219">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-brandOrange shrink-0" size={20} data-id="element-220" /> : <ChevronDown className="text-txt-muted shrink-0" size={20} data-id="element-221" />}
              </button>
              {openIndex === i && <div className="px-5 pb-5 md:px-6 md:pb-5 font-sans text-[14px] md:text-[16px] leading-[1.6] md:leading-[1.7] text-txt-body border-t border-line pt-4" data-id="element-222">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3hs buscando sesiones por semana',
    costo: '156hs por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupo que abandona'
  }, {
    sin: 'Sin adaptaciones por nivel',
    costo: 'El nuevo no vuelve'
  }, {
    sin: 'Sin programa anual',
    costo: 'Mismos circuitos'
  }, {
    sin: 'Domingo en Instagram',
    costo: 'Mismo ciclo cada año'
  }];
  return <Section className="bg-bg-base" data-id="element-223">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-224">
        <h2 className="font-display font-extrabold uppercase text-[26px] md:text-[44px] leading-[1.1] text-center mb-8 md:mb-12 text-txt-primary" data-id="element-225">
          ⚖️ ¿CUÁNTO CUESTA{' '}
          <span className="text-brandOrange" data-id="element-226">NO TENERLO?</span>
        </h2>

        <div className="bg-bg-card rounded-[16px] md:rounded-[20px] overflow-hidden border border-line mb-8 md:mb-10" data-id="element-227">
          <div className="grid grid-cols-2 bg-bg-highlight p-3 md:p-5" data-id="element-228">
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-muted" data-id="element-229">
              Sin el MEGAPACK
            </div>
            <div className="font-sans font-bold text-[12px] md:text-[16px] text-txt-primary pl-3 md:pl-5 border-l border-line" data-id="element-230">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-line" data-id="element-231">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-3 md:p-5 gap-3 md:gap-5 items-center" data-id="element-232">
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-txt-muted pr-2" data-id="element-233">
                  {row.sin}
                </div>
                <div className="font-sans text-[12px] md:text-[15px] leading-[1.4] md:leading-[1.6] text-danger font-medium pl-3 md:pl-5 border-l border-line flex items-center gap-1.5" data-id="element-234">
                  <span data-id="element-235">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="font-sans font-bold text-base md:text-xl text-center text-txt-primary leading-snug" data-id="element-236">
          El próximo lunes puede ser diferente.
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-bg-alt border-t border-line pt-12 md:pt-16 pb-20 md:pb-24" data-id="element-237">
      <FadeIn className="max-w-[700px] mx-auto text-center" data-id="element-238">
        <div className="mb-10 md:mb-12" data-id="element-239">
          <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[11px] text-brandOrange mb-3 md:mb-4" data-id="element-240">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="inline-flex items-center gap-2 md:gap-3 bg-bg-card border-2 border-brandOrange px-5 py-3 md:px-6 md:py-4 rounded-[14px] shadow-[0_0_20px_rgba(255,107,0,0.3)]" data-id="element-241">
            <span className="font-display font-black text-[28px] md:text-[36px] text-brandOrange leading-none" data-id="element-242">
              {hours.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[28px] md:text-[36px] text-brandOrange leading-none" data-id="element-243">
              :
            </span>
            <span className="font-display font-black text-[28px] md:text-[36px] text-brandOrange leading-none" data-id="element-244">
              {minutes.toString().padStart(2, '0')}
            </span>
            <span className="font-display font-black text-[28px] md:text-[36px] text-brandOrange leading-none" data-id="element-245">
              :
            </span>
            <span className="font-display font-black text-[28px] md:text-[36px] text-brandOrange leading-none" data-id="element-246">
              {seconds.toString().padStart(2, '0')}
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-5 mb-10 md:mb-12" data-id="element-247">
          {/* Option 1 */}
          <div className="bg-bg-card border border-line rounded-[20px] p-5 md:p-8 text-left flex flex-col" data-id="element-248">
            <h4 className="font-sans font-bold text-base md:text-xl text-txt-primary leading-snug mb-2" data-id="element-249">
              📘 MEGAPACK FUNCIONAL 365
            </h4>
            <p className="font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-4 md:mb-6" data-id="element-250">
              6 Tomos + 6 Bonos · 365 sesiones
            </p>
            <div className="mt-auto" data-id="element-251">
              <p className="font-sans font-normal text-[15px] md:text-[18px] line-through text-danger mb-1" data-id="element-252">
                $49.990
              </p>
              <p className="font-display font-black text-[36px] md:text-[52px] leading-none text-txt-primary mb-4 md:mb-6" data-id="element-253">
                $19.990
              </p>
              <CTAButton href="http://centershop.store/cart/47832187764887:1" fullWidth variant="secondary" data-id="element-254">
                QUIERO EL MEGAPACK
              </CTAButton>
            </div>
          </div>

          {/* Option 2 */}
          <div className="bg-bg-card border-2 border-brandOrange rounded-[20px] p-5 md:p-8 text-left relative shadow-[0_0_50px_rgba(255,107,0,0.2),inset_0_0_30px_rgba(255,107,0,0.03)] flex flex-col" data-id="element-255">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brandOrange text-white font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 md:px-3.5 py-1 rounded-full whitespace-nowrap" data-id="element-256">
              ⭐ MÁS ELEGIDO
            </div>
            <h4 className="font-sans font-bold text-base md:text-xl text-txt-primary leading-snug mb-2" data-id="element-257">
              🏆 MEGAPACK + POTENCIADORES
            </h4>
            <p className="font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-body mb-4 md:mb-6" data-id="element-258">
              6 Tomos + 6 Bonos + 6 Potenciadores
            </p>
            <div className="mt-auto" data-id="element-259">
              <p className="font-sans font-normal text-[15px] md:text-[18px] line-through text-danger mb-1" data-id="element-260">
                $67.990
              </p>
              <p className="font-display font-black text-[36px] md:text-[52px] leading-none text-brandOrange mb-4 md:mb-6" data-id="element-261">
                $27.990
              </p>
              <CTAButton href="http://centershop.store/cart/47832191828119:1" fullWidth data-id="element-262">
                QUIERO EL SISTEMA COMPLETO
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-263">
          <span className="flex items-center gap-2" data-id="element-264">
            <Lock size={14} data-id="element-265" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-266">
            <Clock size={14} data-id="element-267" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-268">
            <ShieldCheck size={14} data-id="element-269" /> Garantía 15 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-270">
            <CreditCard size={14} data-id="element-271" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-bg-base border-t border-line py-12 px-6" data-id="element-272">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-273">
        <div data-id="element-274">
          <h2 className="font-display font-black text-xl text-txt-primary mb-1" data-id="element-275">
            🏋️ MEGAPACK FUNCIONAL 365™
          </h2>
          <p className="font-sans font-bold text-sm text-brandOrange" data-id="element-276">
            by CENTER SHOP DIGITAL
          </p>
        </div>

        <p className="font-sans text-[13px] text-txt-muted max-w-md mx-auto" data-id="element-277">
          El sistema de clases listas número 1 para instructores y coaches de
          funcional en Latinoamérica. Porque dar una buena clase no debería
          costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 font-sans text-[13px] text-txt-muted pt-4" data-id="element-278">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-txt-primary transition-colors" data-id="element-279">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-280">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-line space-y-3" data-id="element-281">
          <p className="font-sans text-xs text-txt-faint" data-id="element-282">
            © 2024 Center Shop Digital. Todos los derechos reservados.
          </p>
          <p className="space-x-4 font-sans text-xs text-txt-faint" data-id="element-283">
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-284">
              Términos y condiciones
            </a>
            <span data-id="element-285">·</span>
            <a href="#" className="hover:text-txt-primary transition-colors" data-id="element-286">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};